import { useLocation, Link as RouterLink } from "react-router-dom";
import { Icon, Popover, Tooltip } from "@diemmea/dma-design-system";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getCurrentUserInfo } from "../../services/auth";
import { HEIGHT_MENU } from "../../services/utils";
import { INavbarItem, menu } from "../../services/menu";
import { useAuthStore } from "../../store/auth.store";
import BrandLogo from "../BrandLogo";

const NavigationChevron = ({ className = "" }: { className?: string }) => (
  <svg
    className={className}
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M0 10.59L4.68409 6L0 1.41L1.44205 0L7.57841 6L1.44205 12L0 10.59Z" fill="#CBD6E2" />
  </svg>
);


const Navbar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState<any>(null);
  const authStore = useAuthStore((store) => store)

  // const supportParams = userInfo ?
  //   `?firstname=${userInfo.attributes.name.split(" ")[0]}&lastname=${userInfo.attributes.name.split(" ")[1]}&email=${userInfo.attributes.email}`
  //   : ""

  const supportParams = userInfo?.attributes?.email ? `?email=${userInfo?.attributes?.email}` : ""
  const avatarInitial = userInfo?.attributes?.name?.[0] || userInfo?.attributes?.email?.[0] || ""
  const avatarUrl = `https://placehold.co/100x100/0091ae/FFFFFF?text=${avatarInitial}`

  const initAuth = async () => {
    try {
      const _auth = await getCurrentUserInfo()
      //console.log(_auth)
      setUserInfo(_auth)
    } catch (error) {

    }
  }

  useEffect(() => {
    initAuth()
  }, [])


  return (
    <div className="bg-secondaryUltraDark z-50 sticky top-0 left-0 w-full" style={{ height: HEIGHT_MENU }}>
      <div className="container mx-auto h-full flex justify-between">

        {/** MENU DESKTOP */}
        <div id="menu" className="h-full flex w-full justify-between mr-2">
          <div key={"logo"} className="group inline-block h-full align-middle	">
            <RouterLink className="h-full group-hover:bg-secondaryUltraDark flex mr-3 py-3"
              to={"/"}>
              <BrandLogo light className="h-full max-w-[140px] object-contain" />
            </RouterLink>
          </div>
          <div>
            {menu.map((firstLevel: INavbarItem, index: number) => {
              const pathName = firstLevel.key === "support" ? `${firstLevel.url}${supportParams}` : firstLevel.url;
              const tooltipId = `navbar-tooltip-${firstLevel.key}`;
              return (
                <div key={firstLevel.key} className="group inline-flex items-center h-full align-bottom	relative ">
                  <RouterLink title={t(`navbar.tooltips.${firstLevel.key}.title`)}
                    data-tooltip-id={tooltipId}
                    data-tooltip-place="bottom"
                    data-tooltip-offset={12}
                    to={pathName!}
                    state={{ from: location.pathname }}
                    target={firstLevel.key === "settings" ? "_self" : "_blank"}
                    rel={firstLevel.key === "settings" ? undefined : "noreferrer"}
                    className={`outline-none focus:outline-none mx-2 inline-flex items-center hover:bg-secondary transition-all bg-opacity-55 p-2 rounded-full`}>
                    {
                      firstLevel.key === "documentation" ? <Icon icon="documentation" fill="white" width={24} height={24} />
                        : firstLevel.key === "support" ? <Icon icon="support" color="white" width={24} height={24} className="cursor-pointer" />
                          : firstLevel.key === "settings" && <Icon icon="cog" color="white" width={24} height={24} className="cursor-pointer" />
                    }


                    {/* <span className={`pl-2 text-white text-s`}>
                      {t(`navbar.${firstLevel.key}`)}
                    </span> */}
                    {firstLevel.items?.length ? (
                      <span>
                        <NavigationChevron className="rotate-90 ease-in-out" />
                      </span>
                    ) : null}
                  </RouterLink>
                  <Tooltip.TooltipContent
                    id={tooltipId}
                    place="bottom"
                    offset={12}
                    opacity={1}
                  >
                    <span className="block text-xs font-semibold">
                      {t(`navbar.tooltips.${firstLevel.key}.title`)}
                    </span>
                  </Tooltip.TooltipContent>
                  {firstLevel.items?.length ? (
                    <ul style={{ width: "150%" }}
                      className="z-50 bg-secondaryUltraDark py-3 transform scale-0 group-hover:scale-100 absolute  	 ease-in-out origin-top min-w-32"
                    >
                      {firstLevel.items.map((secondLevel: INavbarItem) => {
                        return (
                          <div key={secondLevel.key}>
                            {!secondLevel.items?.length ? (
                              <li
                                key={secondLevel.key}
                                className="hover:bg-secondaryUltraDark text-white text-xs"
                              >
                                <RouterLink to={secondLevel.key} className="px-4 py-2 block w-full">{t(secondLevel.title)}</RouterLink>
                              </li>
                            ) : (
                              <li
                                key={secondLevel.key}
                                className="hover:bg-secondaryUltraDark"
                              >
                                <RouterLink to={secondLevel.key} className="outline-none focus:outline-none px-0 py-0 flex items-center">
                                  <span className="pr-1 flex-1 text-white text-xs">
                                    <span className="px-3 py-2 block w-full">{t(secondLevel.title)}</span>
                                  </span>
                                  {secondLevel.items.length ? (
                                    <span className="mr-auto">
                                      <NavigationChevron className="rotate-90 ease-in-out" />
                                    </span>
                                  ) : null}
                                </RouterLink>
                                {secondLevel.items.length ? (
                                  <ul style={{ right: 1.5 }}
                                    className="z-50 bg-secondaryUltraDark h-full  absolute top-0 right-0 
                                                         	 ease-in-out origin-top-left
                                                        min-w-32
                                                        "
                                  >
                                    {secondLevel.items.map((thirdLevel: INavbarItem) => {
                                      return (
                                        <li
                                          key={thirdLevel.key}
                                          className="hover:bg-secondaryUltraDark text-white text-xs"
                                        >
                                          <RouterLink to={thirdLevel.key} className="px-3 py-2 block w-full">{thirdLevel.title}</RouterLink>
                                        </li>
                                      )
                                    })}
                                  </ul>
                                ) : null}
                              </li>
                            )}
                          </div>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>


        {/** MENU SETTINGS */}
        <div id="menu-settings" className="h-full flex items-center w-fit">
          <div className="group flex h-full items-center w-fit">
            <Popover.PopoverWrapper>
              <Popover.PopoverTrigger asChild>
                <button type="button" className="group flex items-center w-fit outline-none focus:outline-none">
                  <img
                    src={avatarUrl} //TODO: Change img
                    alt="Avatar"
                    className="w-[40px] h-[40px] rounded-full object-cover"
                    loading="lazy"
                  />
                  <Icon icon="arrowdown" width={12} className="ml-[9px] cursor-pointer transition-transform duration-200 ease-in-out group-data-[state=open]:rotate-180" color="white" style={{ width: 12 }} />
                </button>
              </Popover.PopoverTrigger>
              <Popover.PopoverContent
                align="end"
                sideOffset={24}
                hideArrow
                className="navbar-profile-popover !p-0 !bg-transparent !shadow-none !rounded-none !border-0 !text-black"
              >
                <div
                  className="relative w-[336px] bg-white border border-medal"
                  style={{
                    boxShadow: "0 12px 22px rgba(51, 71, 91, 0.18)",
                    fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                  }}
                >
                  <div className="absolute -top-[8px] right-[19px] w-[25px] h-[25px] rotate-45 bg-white border-l border-t border-medal" />
                  <div className="relative bg-white">
                    <div className="flex px-[30px] pt-[18px] pb-3">
                      <img
                        alt="Avatar"
                        src={avatarUrl}
                        className="w-[40px] h-[40px] rounded-full object-cover"
                        loading="lazy"
                      />
                      <div className="flex min-w-0 flex-col pl-[19px] pt-0.5">
                        <span className="truncate font-semibold text-xs text-black leading-none">{userInfo?.attributes?.name}</span>
                        {
                          userInfo?.attributes?.email ?
                            <span className="mt-2 truncate text-xxs text-lightgray leading-none">{userInfo?.attributes?.email}</span>
                            : null
                        }
                      </div>
                    </div>
                    <div className="border-t border-medal">
                      <RouterLink
                        to="/settings/general/backoffice"
                        className="flex h-[51px] w-full items-center justify-between px-[30px] text-left text-xs font-medium text-black transition-colors hover:bg-gray-50 outline-none focus:outline-none"
                      >
                        <span>Settings</span>
                        <NavigationChevron />
                      </RouterLink>
                    </div>
                    <div className="border-t border-medal">
                      <RouterLink
                        to="/settings/subscription-add-ons"
                        className="flex h-[51px] w-full items-center justify-between px-[30px] text-left text-xs font-medium text-black transition-colors hover:bg-gray-50 outline-none focus:outline-none"
                      >
                        <span>Subscription & Add-ons</span>
                        <NavigationChevron />
                      </RouterLink>
                    </div>
                    <div className="flex h-[54px] items-end px-[30px] pb-4 border-t border-medal">
                      <button type="button"
                        className="text-s font-bold text-secondary no-underline hover:text-secondary hover:underline outline-none transition-all"
                        style={{ fontFamily: "'Source Sans 3', Helvetica, Arial, sans-serif" }}
                        onClick={async () => {
                          try {
                            await authStore.logout()
                          } catch (error: any) {
                            console.log("Errore catch", error)
                          }
                        }}>Sign out</button>
                    </div>
                  </div>
                </div>
              </Popover.PopoverContent>
            </Popover.PopoverWrapper>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
